module.exports = __webpack_public_path__ + "b1ce4e9efbdaf7ddd246ca7ea2a719c7.png";